<form [formGroup]="parentForm">
  <div class="container">
    <mat-form-field class="hint">
      <input
        matInput
        placeholder="Name"
        autocomplete="off"
        formControlName="name"
        required
      />
      <mat-hint>A name to describe the Post Type</mat-hint>
    </mat-form-field>
    <mat-form-field class="hint">
      <input
        matInput
        placeholder="Event Type ID"
        autocomplete="off"
        formControlName="eventTypeId"
      />
      <mat-hint>The event that will generate posts of this type</mat-hint>
    </mat-form-field>
    <mat-form-field class="hint">
      <mat-label>Channel</mat-label>
      <mat-select formControlName="channel">
        <mat-option *ngFor="let channel of channels$ | async" [value]="channel">
          {{ channel }}
        </mat-option>
      </mat-select>
      <mat-hint>
        Similar post types should be contained within the same channel
      </mat-hint>
    </mat-form-field>
    <mat-form-field
      class="hint"
      *ngIf="parentForm.get('channel').value === newChannelOption"
    >
      <input
        matInput
        placeholder="New Channel Name"
        autocomplete="off"
        formControlName="newChannel"
        required
      />
      <mat-hint>
        The name of the new channel that will be created for this post type
      </mat-hint>
    </mat-form-field>
    <mat-form-field class="hint">
      <input
        matInput
        placeholder="Post ID Template"
        autocomplete="off"
        formControlName="postIdTemplate"
        required
      />
      <mat-hint ngNonBindable>
        The templated identifier for a post to be created from the event. This
        allows for multiple events to update the same post, if desired. Use the
        {{}} syntax to insert data from the event matching that path into the
        template.
      </mat-hint>
    </mat-form-field>
    <mat-form-field class="hint">
      <input
        matInput
        placeholder="Partner ID Path"
        autocomplete="off"
        formControlName="partnerIdPath"
        required
      />
      <mat-hint>The path to the partner id on the event</mat-hint>
    </mat-form-field>
    <mat-form-field class="hint">
      <input
        matInput
        placeholder="Market ID Path"
        autocomplete="off"
        formControlName="marketIdPath"
        required
      />
      <mat-hint>The path to the market id on the event</mat-hint>
    </mat-form-field>
    <mat-form-field class="hint">
      <!--      TODO: Make a common resources UI for account group id and others instead -->
      <input
        matInput
        placeholder="Account Group ID Path"
        autocomplete="off"
        formControlName="accountGroupIdPath"
      />
      <mat-hint>The path to the account group id on the event</mat-hint>
    </mat-form-field>
    <mat-form-field class="hint">
      <input
        matInput
        placeholder="User ID Path"
        autocomplete="off"
        formControlName="userIdPath"
      />
      <mat-hint>
        The path to the user id on the event that the post will be attributed to
      </mat-hint>
    </mat-form-field>
  </div>
</form>
